<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش درس ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-select color="black" v-model="order" label="نوع ترتیب درس ها را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getItems"></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/items/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات درس ها</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/items/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت درس جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                :headers="headers"
                :items="items.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-switch
                      v-model="singleExpand"
                      label="فقط یک سطر باز شود."
                      class="mt-2"
                  ></v-switch>
                </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="12">توضیحات :
                      {{ item.description }}
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <!--                <v-tooltip bottom>-->
                <!--                  <template v-slot:activator="{ on, attrs }">-->
                <!--                    <v-icon @click="$router.push('/items/item-files/assign/'+item.id)"-->
                <!--                            v-bind="attrs"-->
                <!--                            v-on="on"-->
                <!--                            class="mx-1" color="info"-->
                <!--                    >-->
                <!--                      mdi-relation-many-to-many-->
                <!--                    </v-icon>-->
                <!--                  </template>-->
                <!--                  <span class="tooltip-text">اتصال درس به فایل ها</span>-->
                <!--                </v-tooltip>-->

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="$router.push('/items/item-files/order/'+item.id)"
                            v-bind="attrs"
                            v-on="on"
                            class="mx-1" color="teal"
                    >
                      mdi-order-numeric-descending
                    </v-icon>
                  </template>
                  <span class="tooltip-text">ترتیب فایل های درس</span>
                </v-tooltip>
                <v-icon class="mx-1" color="purple" @click="$router.push('/items/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
              <template
                  v-slot:[`item.cover_file`]="{ item }">
                <img :src="item.cover_file" height="150" width="150" :alt="item.title">
              </template>
              <template
                  v-slot:[`item.visibility`]="{ item }">
                <span v-if="item.visibility">قابل مشاهده</span>
                <span v-else>مخفی</span>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="items.current_page"
                :length="items.last_page"
                circle
                @input="getItems"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این آیتم اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ItemIndex",
  data() {
    return {
      selectedEntityId: null,
      deleteDialog: false,
      expanded: [],
      singleExpand: false,
      loading: true,
      orderItems: [
        {name: 'بر اساس دسته بندی', value: 'category_id'},
        {name: 'بر اساس وضعیت نمایش', value: 'visibility'},
        {name: 'بر اساس اولویت', value: 'order'},
        {name: 'بر اساس زمان ساخت', value: 'created_at'},
      ],
      order: 'created_at',
      items: {
        current_page: 1
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'دسته بندی', value: 'category_name', align: 'center', width: '20%'},
        {text: 'عنوان', value: 'title', align: 'center', width: '10%'},
        {text: 'وضعیت نمایش', value: 'visibility', align: 'center', width: '10%'},
        {text: 'اولویت', value: 'order', align: 'center', width: '3%'},
        {text: 'کاور', value: 'cover_file', align: 'center'},
        {text: 'تاریخ ساخت', value: 'created_at_fa', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '10%'},
      ],
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      let url = '/course/item/index?page=' + this.items.current_page ?? 1
      url = url + '&order=' + this.order
      window.axios.get(url).then((res) => {
        this.items = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(itemId) {
      this.selectedEntityId = itemId
      this.deleteDialog = true
    },
    finalDestroy() {
      window.axios.delete('course/item/delete/' + this.selectedEntityId).then(() => {
        this.getItems()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    }
  }
}
</script>

<style scoped>

</style>